﻿// Globalize object is freezed when the following is used
// import * as Globalize from "globalize/lib/globalize.js";
// As rollup thinks it's a namespace

import defaultExport from "globalize/lib/globalize.js";

// it seems there is a difference between rolldown and rollup export handling, so we need to check for both cases
const Globalize = defaultExport.Globalize || defaultExport;

let currentIsSet = false;
const oldGlobalizeCulture = Globalize.culture.bind(Globalize);

Globalize.culture = function(selector) {
	if (!currentIsSet) {
		if (selector === undefined) {
			for (var c in this.cultures) { /* do nothing, fast-forward to last */ }
			oldGlobalizeCulture(c);
		}
		currentIsSet = true;
	}
	return oldGlobalizeCulture(selector);
};

export { Globalize };